import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../lib/auth";
import { formatApiError } from "../../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      await login(email, pass);
      nav("/admin");
    } catch (er) {
      setErr(formatApiError(er.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-ink px-6">
      <div className="w-full max-w-md card-brutal">
        <p className="overline">Studio access</p>
        <h1 className="mt-3 font-display text-4xl uppercase text-white">Welcome back, <span className="text-rose">Lisa.</span></h1>
        <p className="mt-2 text-sm text-white/70">Sign in to manage bookings, jacket briefs and workshop dates.</p>
        <form onSubmit={submit} className="mt-8 space-y-5">
          <label className="block">
            <span className="text-[10px] uppercase tracking-[0.25em] text-gold font-bold">Email</span>
            <input data-testid="admin-email" required type="email" value={email} onChange={e => setEmail(e.target.value)} className="input-brutal mt-2" />
          </label>
          <label className="block">
            <span className="text-[10px] uppercase tracking-[0.25em] text-gold font-bold">Password</span>
            <input data-testid="admin-password" required type="password" value={pass} onChange={e => setPass(e.target.value)} className="input-brutal mt-2" />
          </label>
          {err && <p data-testid="admin-error" className="text-sm text-rose">{err}</p>}
          <button data-testid="admin-login-btn" disabled={busy} className="btn-accent w-full justify-center disabled:opacity-50">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
